// 课程库 - 试题  TableHeader
export let QuestionTableHeader = [
  {prop: 'taskName', label: '标题', showOverflow: true, align: 'left'},
  {prop: 'questionTypeName', label: '题型', width: 120},
  {prop: 'difficulty', label: '难度', width: 120},
  {prop: 'score', label: '建议分数', width: 120},
  {prop: 'operation', label: '操作',width: 200, SlotType:{
    buttons:[
      {
        name: '预览',
        emitName: 'preview', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
        buttonStyle: "marign-left: 24px"
      },
    ]
  }}
]
// 课程库 - 试题-dialog  TableHeader
export let QuestionDialogTableHeader = [
  {prop: 'taskName', label: '标题', showOverflow: true, align: 'left'},
  {prop: 'questionTypeName', label: '题型', width: 90},
  {prop: 'difficulty', label: '难度', width: 90},
  {prop: 'score', label: '建议分数', width: 90},
]
// 课程库 - 试卷  TableHeader
export let TestPaperTableHeader = [
  {prop: 'paperName', label: '试卷名称', showOverflow: true, align: 'left'},
  {prop: 'totalScore', label: '试卷总分', width: 120},
  {prop: 'questionCount', label: '试题数量', width: 120},
  {prop: 'paperType', label: '用途', width: 120},
  {prop: 'createTime', label: '创建时间', width: 140},
  {prop: 'updateTime', label: '最后编辑时间', width: 140},
  {prop: 'operation', label: '操作',width: 200, SlotType:{
    buttons:[
      {
        name: '预览',
        emitName: 'preview', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
        buttonStyle: "marign-left: 24px"
      },
    ]
  }}
]
// 课程库 - 试卷  TableHeader 信息技术用
export let papersListHeader = [
  {prop: 'paperName', label: '试卷名称', showOverflow: true, align: 'left', sortable: true},
  {prop: 'totalScore', label: '试卷总分', width: 100, sortable: true},
  {prop: 'questionCount', label: '试题数量', width: 100, sortable: true},
  {prop: 'paperType', label: '用途', width: 100, sortable: true},
  {prop: 'createTime', label: '创建时间', width: 140, sortable: true},
  {prop: 'updateTime', label: '最后编辑时间', width: 140, sortable: true},
  {prop: 'operation', label: '操作',width: 200, SlotType:{
    buttons:[
      {
        name: '预览',
        emitName: 'preview', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '编辑',
        emitName: 'edit', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '复制',
        emitName: 'copy', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
        buttonStyle: "marign-left: 24px"
      },
    ]
  }}
]
// 课程库 - 试卷-dialog  TableHeader
export let TestPaperDialogTableHeader = [
  {prop: 'paperName', label: '试卷名称', showOverflow: true, align: 'left'},
  {prop: 'totalScore', label: '试卷总分', width: 90},
  {prop: 'questionCount', label: '试题数量', width: 90},
  {prop: 'paperType', label: '用途', width: 90},
  {prop: 'createTime', label: '创建时间', width: 140},
  {prop: 'totalTime', label: '推荐考试时长', width: 120},
]
// 课程预览 - 视频、PPT、文档  TableHeader
export let PreviewFileHeader = [
  {prop: 'num', label: '序号', width: 60},
  {prop: 'name', label: '文件名称', showOverflow: true, align: 'left'},
  {prop: 'sizeStr', label: '大小', width: 100},
  {prop: 'operation', label: '操作', width: 150, SlotType:{
    buttons:[
      {
        name: '下载',
        emitName: 'download', // 事件Type 必传
        buttonType: 'text',
        buttonStyle: "marign-left: 24px",
        isShow: ['isDownload',1 , 1] //是否显示按钮  [0]: 要判断的字段  [2]: 这个字段的预选值  [1]:等于预选值返回True
      },
      {
        name: '预览',
        emitName: 'preview', // 事件Type 必传
        buttonType: 'text',
        buttonStyle: "marign-left: 24px"
      },
    ]
  }}
]
// 课程预览 - 试题  TableHeader
export let PreviewQuestionHeader = [
  {prop: 'num', label: '序号', width: 60},
  {prop: 'taskName', label: '标题', showOverflow: true, align: 'left'},
  {prop: 'questionTypeName', label: '题型', width: 120},
  {prop: 'difficulty', label: '难度', width: 120},
  {prop: 'score', label: '建议分数', width: 120},
  {prop: 'operation', label: '操作',width: 100, SlotType:{
    buttons:[
      {
        name: '预览',
        emitName: 'preview', // 事件Type 必传
        buttonType: 'text',
      },
    ]
  }}
]
// 课程预览 - 试卷  TableHeader
export let PreviewTestPaperHeader = [
  {prop: 'num', label: '序号', width: 60},
  {prop: 'paperName', label: '试卷名称', showOverflow: true, align: 'left'},
  {prop: 'paperType', label: '用途', width: 120},
  {prop: 'totalScore', label: '试卷总分', width: 120},
  {prop: 'questionCount', label: '试题数量', width: 120},
  {prop: 'totalTime', label: '推荐考试时长', width: 120},
  {prop: 'operation', label: '操作',width: 100, SlotType:{
    buttons:[
      {
        name: '预览',
        emitName: 'preview', // 事件Type 必传
        buttonType: 'text',
      },
    ]
  }}
]
// 教务中心 - 教师管理 TableHeader
export let TeacherTableHeader = [
  {prop: 'num', label: '序号', width: 55},
  {prop: 'userName', label: '账号', align: 'left'},
  {prop: 'name', label: '教师姓名', align: 'left'},
  {prop: 'idCardStr', label: '证件号', align: 'left'},
  {prop: 'mobileStr', label: '手机号', align: 'left'},
  {prop: 'organizationStr', label: '所属组织', align: 'left'},
  // {prop: 'auditStatusStr', label: '审核状态', width: 100, align: 'left'},    // 王进 影藏
  {prop: 'operation', label: '操作', width: 230, SlotType:{}}
]
// 教务中心 - 学生管理 TableHeader
export let StudentTableHeader = [
  {prop: 'num', label: '序号', width: 55},
  {prop: 'userName', label: '账号', align: 'left'},
  {prop: 'name', label: '姓名', align: 'left'},
  {prop: 'idCardStr', label: '证件号', align: 'left'},
  {prop: 'schoolDate', label: '入学年份', align: 'left', width: 100,},
  {prop: 'mobileStr', label: '手机号', align: 'left'},
  {prop: 'teachingClass', label: '行政班', align: 'left'},
  {prop: 'firstStructName', label: '一级组织', align: 'left'},
  {prop: 'secondStructName', label: '二级组织', align: 'left'},
  {prop: 'operation', label: '操作', width: 160, SlotType:{}}
]
// 班级管理 - 学生管理 TableHeader
export let StudentTableHeader1 = [
  {prop: 'num', label: '序号', width: 55},
  {prop: 'userName', label: '账号', align: 'left'},
  {prop: 'name', label: '姓名', align: 'left'},
  {prop: 'idCardStr', label: '证件号', align: 'left'},
  {prop: 'schoolDate', label: '入学年份', align: 'left', width: 100,},
  {prop: 'mobileStr', label: '手机号', align: 'left'},
  {prop: 'operation', label: '操作', width: 160, SlotType:{}}
]
// 教务中心 - 开课计划 TableHeader
export let PlanTableHeader = [
  {prop: 'num', label: '序号', width: 70},
  {prop: 'className', label: '行政班', align: 'left'},
  {prop: 'studentCountStr', label: '人数', align: 'left'},
  {prop: 'isUploadStr', label: '状态', align: 'left'},
  {prop: 'operation', label: '操作', width: 180, SlotType:{
    buttons:[
      {
        name: '导入',
        emitName: 'import', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '查看',
        emitName: 'preview', // 事件Type 必传
        buttonType: 'text',
        isDisabled: ['isUpload',0 , 1] //是否禁用按钮  [0]: 要判断的字段  [2]: 这个字段的预选值  [1]:等于预选值返回True
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
        isDisabled: ['isUpload',0 , 1] //是否禁用按钮  [0]: 要判断的字段  [2]: 这个字段的预选值  [1]:等于预选值返回True
      },
    ]
  }}
]
// 教务中心 - 班课统计 TableHeader
export let StatisticsTableHeader = [
  {prop: 'num', label: '序号', width: 55},
  {prop: 'name', label: '班级名称', align: 'left'},
  {prop: 'courseName', label: '所属课程', align: 'left'},
  {prop: 'teacherUserName', label: '带班教师', align: 'left'},
  {prop: 'studentNum', label: '学员数量', width: 80, align: 'left'},
  {prop: 'timeStr', label: '开课时间', width: 110, align: 'left'},
  {prop: 'statusStr', label: '状态', width: 90, align: 'left'},
  {prop: 'operation', label: '操作', width: 150, SlotType:{
    buttons:[
      {
        name: '学员',
        emitName: 'student', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '统计',
        emitName: 'statistics', // 事件Type 必传
        buttonType: 'text',
      },
    ]
  }}
]
// 教务中心 - 组织管理-班级管理 ClassTableHeader
export let ClassTableHeader = [
  {prop: 'num', label: '序号', width: 55},
  {prop: 'className', label: '班级名称', align: 'left'},
  {prop: 'firstStructName', label: '一级组织', align: 'left'},
  {prop: 'secondStructName', label: '二级组织', align: 'left'},
  {prop: 'operation', label: '操作', width: 200, SlotType:{
    buttons:[
      {
        name: '学生管理',
        emitName: 'student', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '编辑',
        emitName: 'edit', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
      },
    ]
  }}
]
// 教务中心 - 组织管理-角色权限 TableHeader
export let RoleTableHeader = [
  {prop: 'num', label: '序号', width: 55},
  {prop: 'roleName', label: '角色名称', align: 'left'},
  {prop: 'remark', label: '角色描述', align: 'left'},
  {prop: 'operation', label: '操作', width: 150, SlotType:{
    buttons:[
      {
        name: '编辑',
        emitName: 'edit', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
      },
    ]
  }}
]
// 教务中心 - 组织管理-设置管理员 TableHeader
export let AdminTableHeader = [
  {prop: 'num', label: '序号', width: 55},
  {prop: 'userName', label: '账号', align: 'left'},
  {prop: 'name', label: '姓名', align: 'left'},
  {prop: 'roleStr', label: '角色', align: 'left'},
  {prop: 'authority', label: '管理权限', align: 'left'},
  {prop: 'statusStr', label: '状态', width: 80, align: 'left'},
  {prop: 'operation', label: '操作', width: 180, SlotType:{
    buttons:[
      {
        name: '编辑',
        emitName: 'edit', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '重置密码',
        emitName: 'reset', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
      },
    ]
  }}
]
// 教学班 - 助教设置 TableHeader
export let assistantTableHeader = [
  {prop: 'name', label: '助教姓名', align: 'left'},
  {prop: 'userName', label: '账号', align: 'left'},
  {prop: 'jurisdiction', label: '管理权限', align: 'left'},
  {prop: 'operation', label: '操作', width: 150, SlotType:{
    buttons:[
      {
        name: '权限设置',
        emitName: 'setting', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
      },
    ]
  }}
]
// 课程库 - 课程共建设置 TableHeader
export let curriculumConstructionTableHeader = [
  {prop: 'name', label: '教师姓名', align: 'left'},
  {prop: 'userName', label: '账号', align: 'left'},
  {prop: 'jurisdiction', label: '可用权限', align: 'left'},
  {prop: 'operation', label: '操作', width: 150, SlotType:{
    buttons:[
      {
        name: '设置',
        emitName: 'setting', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '移除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
      },
    ]
  }}
]

// 作业 - 老师端 - 作业管理 TableHeader
export let workManageTableHeader = [
  {prop: 'name', label: '作业名称', align: 'left', showOverflow: true,},
  {prop: 'submitStr', label: '提交', width: 90,  align: 'left'},
  {prop: 'await', label: '待批', width: 90, align: 'left'},
  {prop: 'timeStr', label: '作答时间', align: 'left'},
  {prop: 'statusStr', label: '状态', width: 90, align: 'left'},
  {prop: 'operation', label: '操作', width: 170, SlotType:{
    buttons:[
      {
        name: '批阅',
        emitName: 'remark', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '查看',
        emitName: 'check', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '设置',
        emitName: 'set', // 事件Type 必传
        buttonType: 'text',
        isDisabled: ['isEdit',1, 0]
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
        isDisabled: ['isDelete',1, 0] //isDelete 0 可删除   1 不可删除
      },
    ]
  }}
]

// 作业 - 老师端 - 作业模版 TableHeader
export let workTemplateTableHeader = [
  {prop: 'name', label: '作业模版名称', align: 'left', showOverflow: true,},
  {prop: 'catalogName', label: '所属章节', align: 'left'},
  {prop: 'operation', label: '操作', width: 150, SlotType:{
    buttons:[
      {
        name: '发作业',
        emitName: 'issue', // 事件Type 必传
        buttonType: 'text',
        isDisabled: ['isPublish',1, 0] //isPublish 0 可发作业   1 不可发
      },
      {
        name: '编辑',
        emitName: 'edit', // 事件Type 必传
        buttonType: 'text',
        isDisabled: ['isEdit',1, 0] //isEdit 0 可编辑   1 不可编辑
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
        isDisabled: ['isDelete',1, 0] //isDelete 0 可删除   1 不可删除
      },
    ]
  }}
]

// 作业 - 老师端 - 作业批阅 TableHeader
export let workRemarkTableHeader = [
  {prop: 'studentName', label: '姓名', align: 'left'},
  {prop: 'studentNumber', label: '学号', align: 'left'},
  {prop: 'administrativeClassName', label: '行政班', align: 'left'},
  {prop: 'statusStr', label: '状态', align: 'left'},
  {prop: 'submitTime', label: '提交时间', align: 'left'},
  {prop: 'score', label: '得分', align: 'left'},
  {prop: 'operation', label: '操作', width: 60, SlotType:{
    buttons:[
      {
        name: '批阅',
        emitName: 'remark', // 事件Type 必传
        buttonType: 'text',
        isDisabled: ['status',2, 1] //状态 0待批阅 1已批阅 2未提交
      },
    ]
  }}
]

// 作业 - 老师端 - 课程 - 作业库 TableHeader
export let courseWorkTemplateTableHeader = [
  {prop: 'name', label: '作业模版名称', align: 'left', showOverflow: true,},
  {prop: 'catalogName', label: '所属章节', align: 'left'},
  {prop: 'operation', label: '操作', width: 150, SlotType:{
    buttons:[
      {
        name: '编辑',
        emitName: 'edit', // 事件Type 必传
        buttonType: 'text',
      },
      {
        name: '删除',
        emitName: 'delete', // 事件Type 必传
        buttonType: 'text',
        isDisabled: ['isDelete',1, 0] //是否禁用按钮  [0]: 要判断的字段  [2]: 这个字段的预选值  [1]:等于预选值返回True
      },
    ]
  }}
]

// 作业 - 学生端 - 答题 TableHeader
export let studentManageTableHeader = [
  {prop: 'name', label: '作业名称', align: 'left', showOverflow: true,},
  {prop: 'answerTime',width: 300, label: '作答时间', align: 'left'},
  {prop: 'statustxt', label: '作业状态', align: 'left'},
  {prop: 'answerStatustxt', label: '作答状态', align: 'left'},
  {prop: 'operation', label: '操作', width: 170, SlotType:{
    buttons:[
      {
        name: '作答',
        emitName: 'zuoda', // 事件Type 必传
        buttonType: 'text',
        isShow: ['zdStatus',1, 1]
      },
      {
        name: '查看',
        emitName: 'check', // 事件Type 必传
        buttonType: 'text',
        isShow: ['ckStatus',1 , 1]
      },
    ]
  }}
]



// WEBPACK FOOTER //
// ./src/views/szrt_revision/global/table_header_data.js